import React from 'react';
import classnames from 'classnames';

import { RichTextField } from '../../RichTextField/RichTextField';
import StrapiButton from '../../StrapiLink/StrapiButton';
import { TwoColumnsFragment } from '../../../../graphql.schema';

import * as styles from './StrapiTwoColumns.module.scss';

export const StrapiTwoColumns: React.FC<TwoColumnsFragment> = ({
  leftColumn,
  leftCta,
  rightColumn,
  rightCta,
  shadedBackground,
}) => {
  return (
    <div
      className={classnames(styles.root, {
        [styles.alternative]: shadedBackground,
      })}
    >
      <div className={classnames(styles.wrapper, 'container')}>
        <div>
          <h3 className={classnames('title is-3')}>{leftColumn?.title}</h3>
          <RichTextField className={styles.columnContent} content={leftColumn?.content} />
          {leftCta ? <StrapiButton {...leftCta} type="secondary" className={styles.cta} /> : null}
        </div>
        <div>
          <h3 className={classnames('title is-3')}>{rightColumn?.title}</h3>
          <RichTextField className={styles.columnContent} content={rightColumn?.content} />
          {rightCta ? <StrapiButton {...rightCta} type="secondary" className={styles.cta} /> : null}
        </div>
      </div>
    </div>
  );
};
